var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('div',{staticClass:"page-background"}),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('h2',[_vm._v("You have successfully logged out.")])]),_c('b-col',{attrs:{"sm":"12"}},[_c('router-link',{staticClass:"gy-btn btn",attrs:{"to":"/signin"}},[_vm._v("Log Back In")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }